/**
 * The Portfolios API path.
 */
export const portfoliosAPIPath = "/portfolios";
/**
 * The Portfolio Builder endpoint suffix.
 */
export const portfolioBuilderEndpointSuffix = "/builder";
